import { ManagerCardComponentModule } from './../../components/manager-card/manager-card.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WeekViewPage } from './week-view';
import { CommonHeaderComponentModule } from '../../components/common-header/common-header.module';
import { StateFooterComponentModule } from '../../components/state-footer/state-footer.module';
 
@NgModule({
  declarations: [
    WeekViewPage
  ],
  imports: [
    CommonHeaderComponentModule,    
    ManagerCardComponentModule,
    StateFooterComponentModule,
    IonicPageModule.forChild(WeekViewPage),
  ],
  exports: [
    WeekViewPage
  ]
})
export class WeekViewModule {}


// WEBPACK FOOTER //
// ./src/pages/week-view/week-view.module.ts